export interface SurveySchema {
  id: SurveyType
  content: string
  answers?: string
  isSubmitted?: boolean
}

export enum SurveyType {
  RCNMidYear = 1,
  ISDMidYear = 2,
  RCNEndOfYear = 3,
  ISDEndOfYear = 4,
}
